import PlainStatusFilter from './plain-status-filter'

export default PlainStatusFilter
